import { ICheckupList } from 'models'

export const defaultCheckupInfo: ICheckupList = {
	diagnosis: [],
	dispose_recommended: false,
	trim: {
		isTrim: false,
		comment: '',
		target_date: 0,
		responsible_id: undefined,
	},
	next_examination_date: 0,
	milk_reject_start: null,
	milk_reject_end: null,
	comment: '',
}
